





























import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import SideBarMixins from './mixins';

@Component
export default class SideBar extends mixins(Vue, SideBarMixins) {}
